import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './Pipeline.css';

function PipelineCard({ p }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="pip-card">
      <div className="pip-top">
        <div className="pip-icon">{p.icon}</div>
        <div>
          <div className="pip-name">{p.name}</div>
          <span className="pip-badge">{p.statut || 'En développement'}</span>
        </div>
      </div>
      <div className="pip-desc">{p.desc}</div>
      {open && p.longDesc && <div className="pip-longdesc">{p.longDesc}</div>}
      {p.longDesc && (
        <button className="pip-more" onClick={() => setOpen(o => !o)}>
          {open ? '▲ Masquer' : '▾ En savoir plus'}
        </button>
      )}
    </div>
  );
}

export default function Pipeline() {
  const { data } = useApp();
  const pipeline = data.pipeline || [];
  if (pipeline.length === 0) return null;

  return (
    <section className="ms bg3" id="pipeline">
      <div className="sh">
        <div className="stag">🚀 Pipeline d'innovation</div>
        <h2 className="stitle">Nos Prochaines Applications</h2>
        <p className="sdesc">
          Des solutions en cours de développement, à l'approche de leur lancement — dont
          <strong> Kotos</strong>, notre plateforme de communication ultra-sécurisée.
        </p>
      </div>
      <div className="pip-grid">
        {pipeline.map(p => <PipelineCard key={p.id} p={p} />)}
      </div>
    </section>
  );
}
